module.exports = __webpack_public_path__ + "static/media/block.9dfca27d.svg";